export {}

//////////////////////////////////////////////////////////////////////////////////////////////////
// Number Prototype
//////////////////////////////////////////////////////////////////////////////////////////////////
// 
//
//
//////////////////////////////////////////////////////////////////////////////////////////////////
if (!Number.prototype.hasOwnProperty('format')){
    Number.prototype.format = function(n: number, x: number): string {
        var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
        return this.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,');
    };
}
if (!Number.prototype.hasOwnProperty('toDate')){
    Number.prototype.toDate = function(): string {
        var date = new Date(Number(this));
        return [date.getFullYear(), (date.getMonth() + 1).toString().padStart(2, '0'), date.getDate().toString().padStart(2, '0')].join("-");
    };
}
if (!Number.prototype.hasOwnProperty('toDateTime')){
    Number.prototype.toDateTime = function(): string {
        var date = new Date(Number(this));
        return this.toDate() + " " + [date.getHours().toString().padStart(2, '0'), date.getMinutes().toString().padStart(2, '0'), date.getSeconds().toString().padStart(2, '0')].join(":");
    };
    
}

//////////////////////////////////////////////////////////////////////////////////////////////////
// String Prototype
//////////////////////////////////////////////////////////////////////////////////////////////////
//
//
//
//////////////////////////////////////////////////////////////////////////////////////////////////
if (!String.prototype.hasOwnProperty('phoneNumberFormat')) {
    String.prototype.phoneNumberFormat = function(): string{
        var phone = this.replace(/-/g, '');
        return (this?.length == phone?.length) ? [phone.substr(0, 3), phone.substr(3, 4), phone.substr(7, 4)].join('-') : this.toString();
    };
}

if (!String.prototype.hasOwnProperty('toDate')) {
    String.prototype.toDate = function(): string {
        var timestamp = (this.length == 13 && !this.match(/[^0-9]/)) ? parseInt(this.toString()) : undefined;
        var date = new Date(timestamp || this.toString());
        return [date.getFullYear(), (date.getMonth() + 1).toString().padStart(2, "0"), date.getDate().toString().padStart(2, "0")].join("-");
    };
}

if (!String.prototype.hasOwnProperty('toDateTime')) {
    String.prototype.toDateTime = function(): string{
        var timestamp = (this.length == 13 && !this.match(/[^0-9]/)) ? parseInt(this.toString()) : undefined;
        var date = new Date(timestamp || this.toString());
        return this.toDate() + " " + [date.getHours().toString().padStart(2, "0"), date.getMinutes().toString().padStart(2, "0"), date.getSeconds().toString().padStart(2, "0")].join(":");
    };
}

//////////////////////////////////////////////////////////////////////////////////////////////////
// Date Prototype
//////////////////////////////////////////////////////////////////////////////////////////////////
//
//
//
//////////////////////////////////////////////////////////////////////////////////////////////////
if (!Date.prototype.hasOwnProperty('addYear')){
    Date.prototype.addYear = function(year: number = 0): number{
        return this.setFullYear(this.getFullYear() + year);
    }
}
if (!Date.prototype.hasOwnProperty('addMonth')){
    Date.prototype.addMonth = function(month: number = 0): number{
        return this.setMonth(this.getMonth() + month);
    }
}
if (!Date.prototype.hasOwnProperty('addDate')){
    Date.prototype.addDate = function(days: number = 0): number{
        return this.setDate(this.getDate() + days);
    }
}
if (!Date.prototype.hasOwnProperty('addHours')){
    Date.prototype.addHours = function(hour: number = 0): number{
        return this.setHours(this.getHours() + hour);
    }
}
if (!Date.prototype.hasOwnProperty('addMinutes')){
    Date.prototype.addMinutes = function(minute: number = 0): number{
        return this.setMinutes(this.getMinutes() + minute);
    }
}
if (!Date.prototype.hasOwnProperty('addSeconds')){
    Date.prototype.addSeconds = function(second: number = 0): number{
        return this.setSeconds(this.getSeconds() + second);
    }
}

//////////////////////////////////////////////////////////////////////////////////////////////////
// Object Prototype
//////////////////////////////////////////////////////////////////////////////////////////////////
//
//
//
//////////////////////////////////////////////////////////////////////////////////////////////////
if (!Object.hasOwnProperty('assignDefined')){
    Object.assignDefined = function(target, ...sources): object {
        for (const source of sources) {
            for (const key of this.keys(source)) {
                const val = source[key];
                if (val !== undefined) {
                    target[key] = val;
                }
            }
        }
        return target;
    };
}

//////////////////////////////////////////////////////////////////////////////////////////////////
// Array Prototype
//////////////////////////////////////////////////////////////////////////////////////////////////
//
//
//
//////////////////////////////////////////////////////////////////////////////////////////////////
if (!Array.hasOwnProperty('shuffle')){
    Array.shuffle = function(array: any[]): any[]{
        for(var i = array.length - 1; i > 0; i--){
            const j = Math.floor(Math.random() * ( i + 1 ));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    }
}
